import React from 'react'
import { useTranslation } from 'react-i18next'

import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../packages/kiti/components/form/Select'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import PlaceTypeSection from '../form/PlaceTypeSection'
import CustomEntitySection from '../form/CustomEntitySection'
import { useModalData } from '../../../../components/modals/ModalsContext'
import FieldsPicker from '../form/FieldsPicker'
import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import RadioListItem from '../../../../components/list/RadioListItem'
import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { COLORS } from '@btime/constants'
import { useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'

export const getFieldsConfigOptions = t => [
  { name: t('all'), id: 'all' },
  { name: t('customize'), id: 'customize' }
]

export default function GeneralSection({ isMultiSelect }) {
  const { t } = useTranslation('export')
  const { entity, empty } = useModalData()
  const { includeReplies } = useForm()
  const fieldsConfigOptions = getFieldsConfigOptions(t)
  const [exportType, setExportType] = React.useState('pdf')
  const { handleChangeIn } = useFormState()

  const handleChangeExportType = React.useCallback(
    selected => {
      setExportType(selected)
      handleChangeIn(['bulkResumeExport'], selected === 'pdf')
    },
    [setExportType, handleChangeIn]
  )

  React.useEffect(() => {
    if (isMultiSelect) {
      handleChangeExportType('pdf')
    }
  }, [isMultiSelect, handleChangeExportType])

  return (
    <>
      <Separator weight={2} />

      {isMultiSelect && (
        <Grid gap={0.5} align="center">
          <Col width={'50%'}>
            <RadioListItem
              label={t('exportPdf')}
              selected={exportType === 'pdf'}
              onSelect={() => handleChangeExportType('pdf')}
            />
          </Col>
          <Col width={'50%'}>
            <RadioListItem
              label={t('exportExcel')}
              selected={exportType === 'excel'}
              onSelect={() => handleChangeExportType('excel')}
            />
          </Col>
        </Grid>
      )}

      {(!isMultiSelect || exportType === 'excel') && (
        <>
          <Separator weight={2} />
          <PlaceTypeSection />
          <CustomEntitySection isMultiSelect={isMultiSelect} />
          {!empty && (
            <>
              <FormItem
                label={t('columns')}
                Input={Select}
                field="fieldsConfig"
                options={fieldsConfigOptions}
                disableEmptyOption
                disabled={includeReplies}
              />

              <FieldsPicker origin={entity} />
            </>
          )}
        </>
      )}

      {isMultiSelect && exportType === 'pdf' && (
        <>
          <FormItem
            label={t('columns')}
            Input={Select}
            field="fieldsConfig"
            options={fieldsConfigOptions}
            disableEmptyOption
            disabled={includeReplies}
          />

          <FieldsPicker origin={entity} />
          <Separator weight={4} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              borderLeft: `3px solid ${COLORS.primary}`,
              backgroundColor: COLORS.light1,
              borderRadius: 3,
              padding: '0.75rem',
              fontSize: '0.875rem'
            }}
          >
            {t('pdfInfo')}
          </div>
        </>
      )}
    </>
  )
}
